<div class="align-items-center display-flex header-bar-wrapper justify-content-space-between">
    <div class="text-24-heavy">{{title}}</div>
    <div class="action-area">
        <ng-content></ng-content>
    </div>
</div>